/* @flow */
import React from 'react';

import Table from 'components/UIKit/Table';
import AnalytesColumns from './AnalytesColumns';
import AnalytesRows from './AnalytesRows';

export default function AnalytesTable({
  children, router, sort, order
}: any): React.Element {
  return (
    <Table>
      <AnalytesColumns sort={sort} order={order} />
      <AnalytesRows router={router}>
        {children}
      </AnalytesRows>
    </Table>
  );
}
